













































































































































import { Component, Prop, Watch, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import BrandsStore from "@/mixins/brandsStore";

// Enums/Data
import { ConditionTypes } from "@/data/enums/affiliates";
import { DiscountTypes } from "@/data/enums/promotions";
import { ConditionInvoiceCategories } from "@/data/affiliates";

// Types
import { IAffiliateTierCondition } from "@/models/affiliate";
import { IAffiliateTierConditionsProviderMethods } from "@/models/providers/affiliateTierConditions";
import { ISortableOptions, ISortableData } from "@/models/reordering";
import { IBillingCycle } from "@/models/constants";

@Component({
  components: {
    "promotion-tags": () =>
      import("@/components/app/admin/catalogue/promotions/promotionTags.vue")
  }
})
export default class AffiliateTierConditions extends Mixins(BrandsStore) {
  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: false })
  public isDeleting!: boolean;

  @Prop({ required: true })
  public affiliateTierConditions!: IAffiliateTierCondition[];

  @Prop({ required: true })
  public billingCycles!: IBillingCycle[];

  @Prop({ required: true })
  public isNewTier!: boolean;

  @Prop({ required: true })
  public reorderConditions!: IAffiliateTierConditionsProviderMethods["reorderConditions"];

  // Variables
  public invoiceCategories = ConditionInvoiceCategories;
  public conditionTypes = ConditionTypes;

  public sortElems: ISortableData[] = [];
  public savedOrder: ISortableData[] = [];
  public sortableOptions: ISortableOptions = {
    chosenClass: "dragged-vessel",
    handle: ".vessel-draggable"
  };
  public isReordering = false;

  // Methods
  public getAmount(condition: IAffiliateTierCondition) {
    if (condition.type === DiscountTypes.PERCENTAGE_BASED) {
      return `${condition.amount}%`;
    }

    return `${_.get(this.brandCurrency, "prefix", "")}${
      condition.amount
    }${_.get(this.brandCurrency, "suffix", "")}`;
  }

  public getBillingTermsNames(billingTerms: IBillingCycle["id"][]) {
    return _.map(billingTerms, billingTerm => {
      if (_.isNull(billingTerm)) return this.$t("_.all_billing_terms");

      return _.get(
        _.find(this.billingCycles, ["months", billingTerm]),
        "name",
        this.$t("_.every_months", { months: billingTerm })
      );
    });
  }

  public getInvoiceCategoriesNames(invoiceCategories: any) {
    return this.$_.map(invoiceCategories, invoiceCategory => {
      return this.$_.get(
        this.$_.find(this.invoiceCategories, ["value", invoiceCategory]),
        "label",
        ""
      );
    });
  }

  public async onDragDrop() {
    this.isReordering = true;
    this.savedOrder = _.cloneDeep(this.sortElems);

    try {
      if (!this.isNewTier) {
        await this.reorderConditions(
          _.map(this.sortElems, sortedElem => {
            return sortedElem.id;
          })
        );
        this.$bus.$emit("refreshAffiliateTierConditions");

        this.$store.dispatch("toast/show", {
          message: this.$t("_.order_updated")
        });
      } else {
        this.$emit(
          "updateSorting",
          _.map(this.sortElems, sortedElem => {
            return sortedElem.id;
          })
        );
      }
    } catch (error) {
      this.sortElems = _.cloneDeep(this.savedOrder);
      this.$buefy.toast.open({
        message: _.get(error, "message", ""),
        type: "is-danger"
      });
    } finally {
      this.isReordering = false;
    }
  }

  public openManageConditionModal(condition = null) {
    if (this.isDisabled) return;
    this.$emit("openManageConditionModal", condition);
  }

  public deleteTierCondition(conditionId) {
    if (this.isDisabled) return;
    this.$emit("deleteTierCondition", conditionId);
  }

  // Watch
  @Watch("affiliateTierConditions", { immediate: true })
  public updateSortableData() {
    this.sortElems = _.cloneDeep(this.affiliateTierConditions);
    this.savedOrder = _.cloneDeep(this.sortElems);
  }
}
